import PreviewComponent from './PreviewComponent'
export default PreviewComponent
